module.exports = __webpack_public_path__ + "img/ch81.7fa5520d.jpg";